import { z } from 'zod';
import { IncidentSchema } from './IncidentSchema';

export const IncidentCollectionSchema = z.object({
  updated: z.string().datetime(),
  incidents: z.array(IncidentSchema),
});
